import axios from "axios";
import AxiosConfig from "./AxiosConfig";

const UserSettings = {
    update: (settings: Object) => {
        axios.post(process.env.REACT_APP_API_URL + "/api/Settings", { UserSettings: settings }, { headers: { Authorization: `bearer ${AxiosConfig.tokenValue()}` } })
            .then(res => {
                //console.log("updated user settings:" , res.data)
            })
            .catch(err => {
                //console.log("error", err);
                AxiosConfig.handleError(err);
            })
    }
}

export default UserSettings